import { hasStatisticsConsent } from '../consent/hasStatisticsConsent.ts';
import { isConsentFirstRegion } from './isConsentFirstRegion.ts';

/**
 * Whether an event may reach OpenPanel right now: the feature is on, and either the visitor is outside Germany and
 * France or has accepted statistics cookies. Re-evaluated on every event, so a withdrawal takes effect at once.
 */
export const canSendToOpenPanel = () =>
    process.env.PUBLIC_OPENPANEL_ENABLED === 'true' && (!isConsentFirstRegion() || hasStatisticsConsent());
